"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _performanceNow = _interopRequireDefault(require("./vendor/performanceNow"));

var _default = (0, _memoizeOne.default)(function (history) {
  var initialPathname = history.location.pathname;
  return {
    pathname: initialPathname,
    listen: function listen(cb) {
      return history.listen(function (_ref) {
        var pathname = _ref.pathname;
        var timestamp = (0, _performanceNow.default)();
        cb({
          timestamp: timestamp,
          pathname: pathname
        });
      });
    }
  };
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5065/js/historyAdapterV4.js
// module id = 629
// module chunks = 209 210 211 212